/*global angular*/
'use strict'

// Adds button that when clicked, scrolls page view to element with passed id
angular.module('whirlwind').directive('wwScrollTo', function ($uiViewScroll) {
  return {
    scope: {
      elementId: '=',
      containerId: '='
    },
    replace: true,
    templateUrl: 'components/ww-scroll-to/ww-scroll-to.html',
    compile ($element, $scope) {
      // Scroll to this element
      let setElementId = $scope.elementId
      let setElement = document.getElementById(setElementId)
      let $setElement = angular.element(setElement)

      // Detect scroll on this container
      let containerId = $scope.containerId
      let $container = angular.element(document.getElementById(containerId))

      // Detect click on this button
      $scope.button = $element.find('button')

      // Returns true if the set element is in view already
      function isSetElementInView () {
        var rect = setElement.getBoundingClientRect()
        var html = document.documentElement

        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || html.clientHeight) &&
          rect.right <= (window.innerWidth || html.clientWidth)
        )
      }

      // Scrolls to set element
      function scrollToSetElement () {
        $uiViewScroll($setElement)
        $element.addClass('ww-scroll-to--hidden')
      }

      // Shows the scroll to element with button only if set element is not in view
      function hideIfElementNotInView () {
        if (isSetElementInView()) {
          $element.addClass('ww-scroll-to--hidden')
        } else {
          $element.removeClass('ww-scroll-to--hidden')
        }
      }

      // Checks if element is in view on scroll of container
      $container.bind('scroll', hideIfElementNotInView)

      // Scrolls to set element on click of button
      $scope.button.on('click', scrollToSetElement)
    }
  }
})
